import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const LanguageToggle = () => {
  const [currentLanguage, setCurrentLanguage] = useState('es');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'es';
    setCurrentLanguage(savedLanguage);
  }, []);

  const toggleLanguage = () => {
    const newLanguage = currentLanguage === 'es' ? 'en' : 'es';
    setCurrentLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium text-text-primary hover:text-primary hover:bg-primary/5 nav-transition"
      aria-label={`Switch to ${currentLanguage === 'es' ? 'English' : 'Spanish'}`}
    >
      <Icon name="Globe" size={16} />
      <span className="font-caption uppercase">
        {currentLanguage === 'es' ? 'EN' : 'ES'}
      </span>
    </button>
  );
};

export default LanguageToggle;